import type { Partner } from '@twlvxtwlv/types'

export const partners: ReadonlyArray<Partner> = [
  {
    name: '360X AG',
    description:
      'Pioneering a new era of tokenisation, 360X is on the mission to open markets and empower users to buy and sell tokenised rights. The Frankfurt-based fintech combines market expertise across art, music, and real estate with leading, innovative technology. We bring 360X on board as an investor and strategic partner to further develop Web 3.0 in the European music market.',
    link: 'https://www.360x.com/',
  },
  {
    name: 'e-pixler',
    description:
      'e-pixler is a Berlin-based digital agency. twelve x twelve has them on board as digital strategist. Their team provides us with innovative technical solutions and ensures our platforms and interfaces are well integrated and perform in the most optimal way.',
    link: 'https://www.e-pixler.com/',
  },
  {
    name: 'Warner Music Central Europe',
    description:
      'Joining forces with Warner Music Central Europe, a renowned leader in the music industry, is a significant milestone for us. Their unwavering commitment to artist development, innovative strategies, and boundary-pushing music releases perfectly aligns with our vision. Through this partnership, we aim to unlock new avenues of growth, elevate the music experience, and empower artists to reach audiences in Central Europe and beyond.',
    link: 'https://www.warnermusic.de/',
  },
  {
    name: 'Ravespace',
    description:
      'Born amidst the pandemic, Ravespace is a Berlin startup that has quickly grown into a full fledged platform hosting, designing and developing virtual parties for music and art lovers around the world. From green screen studio recordings to programming, they are forging the path for new ways of interacting and appreciating music and we are happy to have them as partners for the TxT Metaverse.',
    link: 'https://ravespace.club/about',
  },
  {
    name: 'Universal Music Group',
    description:
      'We are thrilled to partner with Universal Music Group, a global powerhouse in the music industry. With their unparalleled expertise, vast artist roster, and extensive resources, Universal Music Group brings immense value to our mission of revolutionizing the digital music experience. Together, we are poised to redefine the boundaries of creativity, accessibility, and fan engagement in the ever-evolving landscape of music.',
    link: 'https://www.universal-music.de',
  },
  {
    name: 'Exxeta',
    description:
      'Exxeta is driven by a passion for innovation and digital transformation through technological solutions. Exxeta works with companies from startups to established businesses from product strategy to execution. twelve x twelve and Exxeta work together to shape their NFT marketplace for music and art fans.',
    link: 'https://exxeta.com/',
  },
  {
    name: 'GEMA',
    description:
      'GEMA is the German musical copyright monitoring body that manages remuneration claims and entitlements to all its members around the world. In other words, it works towards making sure that composers publishers and lyricists - authors of musical works,can exercise their rights for a fair payment whenever their works are used in public.',
    link: 'https://www.gema.de',
  },
]
